import Header from "../../../Components/Header/Header"
import Sidebar from "../../../Components/Sidebar/Sidebar"
import GardenMasterCardManage from "./GarderDashboardComponent/GardenMasterCard/GardenMasterCardManage"
import React, { useEffect, useState } from 'react'
import { useAuthState } from "../../../Helper/Context"
import { useDispatch, useSelector } from "react-redux"
import { GardenDashMainCountDataAPI } from "../../../Redux/MainCountSlice/GardenMainCount"
import { Loading } from "../../../Helper/Loading"
import { useSearchParams } from "react-router-dom"
import CommonDashboardWardNameDDL from "./CommonDashboardWardNameDDL"
import { AllContain } from "./GarderDashboardComponent/AllContain/AllContain"
import { OfficialVisitN } from "./GardenWorkDailyChecklist/OfficialVisitN"
import { WorkAssignByOfficialsN } from "./GarderDashboardComponent/CivilWorkCard/WorkAssignByOfficialsN"
import { WorkProgressbyContractorN } from "./GarderDashboardComponent/GardenWorkAssign/WorkProgressbyContractorN"
import { GardenReopenCardManageN } from "./GarderDashboardComponent/GardenReopenCard/GardenReopenCardManageN"


export const GardenDashboard = () => {
    const userDetails = useAuthState();
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails
    const { token, UserID } = userDetails.user

    const dispatch = useDispatch()

    // const [show, setShow] = useState('Daily Preventive Work')

    // const [ActiveBtn, SetActiveBtn] = useState('Daily Preventive Work')
    const [ActiveBtn, SetActiveBtn] = useState("Garden Work Assigned by Officials")

    const handleActiveBtn = () => {
        SetActiveBtn();
    };

    const [searchParams] = useSearchParams()
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    const [WorkType, setWorkType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select WorkType",
    })
    const [Countdata, setCountdata] = useState({})
    // const [FinancialYearID, setFinancialYear] = useState('')
    const [HeaderFinancialYear, setHeaderFinancialYear] = useState('')
    const [HeaderMonthID, setHeaderMonthID] = useState('')
    const [MonthID, setMonthID] = useState('')
    const [YearValue, setYearValue] = useState(null)
    const [YearLabel, setYearLabel] = useState(null)
    const [MonthValue, setMonthValue] = useState(null)
    const [MonthLabel, setMonthLabel] = useState(null)
    const [WardValue, setWardValue] = useState(null)
    const [WardLabel, setWardLabel] = useState(null)
    const [HideYearMonth, setHideYearMonth] = useState('')
    const [AssetID, setAssetID] = useState(0)

    const [FinancialYear, setFinancialYear] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    // const [Month, setMonth] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select...",

    // })
    const handleGetFinancialYearID = (FinancialYear, Month) => {
        setHeaderMonthID(Month)
        setHeaderFinancialYear(FinancialYear)
    }

    // console.log(HeaderFinancialYear)

    useEffect(() => {
        const data = {
            M_FinancialYearID: year.ID,
            M_WardID: Ward.ID,
            M_MonthID: Month.ID,
            M_UserID: UserID,
            Flag: "WEB",
            token: token,
            handleGetCount: handleGetCount
        }
        // if (YearValue != 0 || MonthValue != 0  ) {
        dispatch(GardenDashMainCountDataAPI({ data }))
        // }
    }, [year.ID, Month.ID, Ward.ID])

    const { GardenDashCountData, isLoading } = useSelector(state => state.GardenDashMainCountData)

    const handleGetCount = (data) => {
        // console.log("data", data)
        let tempData = {}
        data.forEach((item) => {
            tempData[item.paramName] = item.totalCount
        })
        setCountdata(tempData)
    }

    return (
        <>
            {isLoading && <Loading />}
            {/* <div className="main-content side_shrink position-relative border-radius-lg "></div> */}
            <div>

                <Header
                    // DashboardHeading="Garden Maintenance"
                    setYearValue={setYearValue}
                    setMonthValue={setMonthValue}
                    FinancialYear={FinancialYear}
                    setFinancialYear={setFinancialYear}
                    Month={Month}
                    setMonth={setMonth}
                    setYearLabel={setYearLabel}
                    setMonthLabel={setMonthLabel}
                    setWardValue={setWardValue}
                    setWardLabel={setWardLabel}
                    DashboardName={DashboardName}
                    HideYearMonthDDL='Dashboard'
                    Name="Garden"
                />

                {/* <Sidebar active="dashboard" /> */}

                <div className="wrapper">
                    <Sidebar
                        ProjectTypeId={ProjectTypeId}
                    />
                    <div className="content1 content">

                        {/* <div id="page-content-wrapper"> */}
                        {/* <div className="pcoded-main-container main-row">
                        <div className="pcoded-content "> */}
                        {/* <!-- [ breadcrumb ] start --> */}
                        {/* <WardnameHeaderDDL
                            WardName={WardName}
                            setWardName={setWardName}
                            WLable={WLable}
                            HWard={HWard}
                            flag={flag}
                        /> */}

                        <CommonDashboardWardNameDDL
                            setWardValue={setWardValue}
                            setWardLabel={setWardLabel}
                            setHeaderMonthID={setHeaderMonthID}
                            setHeaderFinancialYear={setHeaderFinancialYear}
                        />

                        {/* <!-- [ Main Content ] start --> <!--  --> */}
                        {/* <GardenMaintainanceComp /> */}



                        <div className=" m-1 p-0 ">
                            <GardenMasterCardManage
                                Countdata={Countdata}
                                YearValue={YearValue}
                                YearLabel={YearLabel}
                                MonthValue={MonthValue}
                                MonthLabel={MonthLabel}
                                WardValue={WardValue}
                                WardLabel={WardLabel}
                                ProjectTypeId={ProjectTypeId}
                                DashboardName={DashboardName}
                                setAssetID={setAssetID}
                            />
                        </div>

                        <div className=" m-1 p-0 pt-2">
                            <AllContain
                                ActiveBtn={ActiveBtn}
                                SetActiveBtn={SetActiveBtn}
                                WorkType={WorkType}
                                setWorkType={setWorkType}
                            />
                        </div>

                        {/* {
                            ActiveBtn == 'Daily Preventive Work' &&

                            <div className="m-1 p-0  mt-3">
                                
                                <GardenWorkDailyChecklist />
                            </div>
                        } */}
                        {
                            ActiveBtn == "Garden Work Assigned by Officials" &&
                            <div className="m-1 p-0  mt-3">
                                {/* <GardenWorkAssignManage
                                    HeaderFinancialYear={HeaderFinancialYear}
                                    HeaderMonthID={HeaderMonthID}
                                    Countdata={Countdata}
                                    handleGetFinancialYearID={handleGetFinancialYearID}
                                    YearValue={YearValue}
                                    YearLabel={YearLabel}
                                    MonthValue={MonthValue}
                                    MonthLabel={MonthLabel}
                                    WardValue={WardValue}
                                    WardLabel={WardLabel}
                                    ProjectTypeId={ProjectTypeId}
                                    DashboardName={DashboardName}
                                /> */}
                                <OfficialVisitN
                                    FinancialYear={FinancialYear?.ID}
                                    Month={Month?.ID}
                                    M_WardID={WardValue}
                                    AssetID={AssetID}
                                    WorkType={WorkType}

                                />

                            </div>
                        }

                        {
                            ActiveBtn == "Work Assign By Officials" &&
                            <div className="m-1 p-0  mt-3">
                                {/* <CivilWorkCardManage
                                    Countdata={Countdata}
                                    YearValue={YearValue}
                                    YearLabel={YearLabel}
                                    MonthValue={MonthValue}
                                    MonthLabel={MonthLabel}
                                    WardValue={WardValue}
                                    WardLabel={WardLabel}
                                    ProjectTypeId={ProjectTypeId}
                                    DashboardName={DashboardName}
                                /> */}
                                <WorkAssignByOfficialsN
                                    ActiveBtn={ActiveBtn}
                                    FinancialYear={FinancialYear?.ID}
                                    Month={Month?.ID}
                                    M_WardID={WardValue}
                                    AssetID={AssetID}
                                    WorkType={WorkType}
                                />

                            </div>
                        }

                        {
                            ActiveBtn == "Work Progress by Contractor" &&
                            <div className="m-1 p-0  mt-3">
                                {/* <WorkProgress
                                    HeaderFinancialYear={HeaderFinancialYear}
                                    HeaderMonthID={HeaderMonthID}
                                    Countdata={Countdata}
                                    handleGetFinancialYearID={handleGetFinancialYearID}
                                    YearValue={YearValue}
                                    YearLabel={YearLabel}
                                    MonthValue={MonthValue}
                                    MonthLabel={MonthLabel}
                                    WardValue={WardValue}
                                    WardLabel={WardLabel}
                                    ProjectTypeId={ProjectTypeId}
                                    DashboardName={DashboardName}
                                /> */}
                                <WorkProgressbyContractorN
                                    ActiveBtn={ActiveBtn}
                                    FinancialYear={FinancialYear?.ID}
                                    Month={Month?.ID}
                                    M_WardID={WardValue}
                                    AssetID={AssetID}
                                    WorkType={WorkType}
                                />

                            </div>
                        }

                        {
                            ActiveBtn == "Reopen Work Progress" &&
                            <div className="m-1 p-0  mt-3">
                                {/* <GardenReopenCardManage
                                    HeaderFinancialYear={HeaderFinancialYear}
                                    HeaderMonthID={HeaderMonthID}
                                    Countdata={Countdata}
                                    handleGetFinancialYearID={handleGetFinancialYearID}
                                    YearValue={YearValue}
                                    YearLabel={YearLabel}
                                    MonthValue={MonthValue}
                                    MonthLabel={MonthLabel}
                                    WardValue={WardValue}
                                    WardLabel={WardLabel}
                                    ProjectTypeId={ProjectTypeId}
                                    DashboardName={DashboardName}
                                /> */}
                                <GardenReopenCardManageN
                                    ActiveBtn={ActiveBtn}
                                />

                            </div>
                        }

                        <div className="m-1 p-0  mt-3">
                            {/* <GardenWorkDailyChecklist /> */}
                        </div>

                    </div>
                </div>
            </div>
        </>


    )
}